/**
 * Tipos e catálogos compartilhados entre server, web e simulator.
 */
export const NXVOLT_VERSION = '0.0.1';
/** Módulos temporariamente indisponíveis para toda a instalação. */
export const DISABLED_MODULE_SLUGS = [];
export function isModuleEnabled(slug) {
    return !DISABLED_MODULE_SLUGS.includes(slug);
}
/**
 * Recursos que seguem disponíveis para integrações, mas não são oferecidos na
 * interface enquanto sua fonte operacional ainda não estiver contratada.
 */
export const HIDDEN_MODULE_SLUGS = ['saude_bateria'];
export function isModuleVisible(slug) {
    return !HIDDEN_MODULE_SLUGS.includes(slug);
}
/** Catálogo canônico. Deve casar com o seed em @nxvolt/db. */
export const MODULES_CATALOG = [
    // principal
    // CCO (ADR 0002) — visão executiva, primeiro item da categoria principal.
    { slug: 'cco', name: 'CCO', category: 'principal', icon: '🎯', order: 5 },
    { slug: 'dashboard', name: 'Dashboard', category: 'principal', icon: '📊', order: 10 },
    // hardware físico
    { slug: 'chargers', name: 'Equipamentos', category: 'carregadores', icon: '🔌', order: 110 },
    { slug: 'charger_approval', name: 'Aprovação OCPP', category: 'carregadores', icon: '✅', order: 120 },
    { slug: 'charging_wall', name: 'Painel Wall', category: 'carregadores', icon: '📺', order: 130 },
    // Renomeado de `battery_health` -> `saude_bateria` na migration 0013 (ADR 0002).
    { slug: 'saude_bateria', name: 'Saúde da Bateria', category: 'carregadores', icon: '❤️', order: 140 },
    { slug: 'maintenance', name: 'Manutenção', category: 'carregadores', icon: '🔧', order: 150 },
    { slug: 'manobrista', name: 'Manobrista', category: 'carregadores', icon: '🚦', order: 160 },
    // operação diária
    { slug: 'live', name: 'Monitor ao Vivo', category: 'operacao', icon: '📡', order: 210 },
    { slug: 'sessions', name: 'Sessões', category: 'operacao', icon: '⚡', order: 220 },
    { slug: 'charge_phases', name: 'Fases de Carga', category: 'operacao', icon: '📈', order: 230 },
    { slug: 'ocpp_logs', name: 'Logs OCPP', category: 'operacao', icon: '📜', order: 240 },
    { slug: 'alerts', name: 'Alertas', category: 'operacao', icon: '🔔', order: 250 },
    { slug: 'orphan_sessions', name: 'Sessões Órfãs', category: 'operacao', icon: '👻', order: 260 },
    { slug: 'heatmap_utilizacao', name: 'Utilização (Heatmap)', category: 'operacao', icon: '🌡️', order: 270 },
    // subestação e API
    { slug: 'telemetria_sub', name: 'Telemetria Sub.', category: 'gestao_eletrica', icon: '🗼', order: 310 },
    { slug: 'energia_demanda', name: 'Energia e Demanda', category: 'gestao_eletrica', icon: '⚡', order: 305 },
    { slug: 'api_access', name: 'Acessos API', category: 'gestao_eletrica', icon: '🛡️', order: 320 },
    // frota
    // { slug: 'fleet', name: 'Veículos', category: 'frota', icon: '🚚', order: 410 },
    // { slug: 'drivers', name: 'Motoristas', category: 'frota', icon: '🪪', order: 420 },
    { slug: 'telemetria_frota', name: 'Telemetria Frota', category: 'frota', icon: '🛰️', order: 430 },
    // { slug: 'mapa_frota', name: 'Mapa ao Vivo', category: 'frota', icon: '🗺️', order: 440 },
    // financeiro
    { slug: 'financial', name: 'Visão Geral', category: 'financeiro', icon: '💰', order: 510 },
    { slug: 'plano_contratado', name: 'Plano Contratado', category: 'financeiro', icon: '📄', order: 520 },
    { slug: 'rel_consumo', name: 'Rel. de Consumos', category: 'financeiro', icon: '📊', order: 530 },
    { slug: 'horario_ponta', name: 'Horário de Ponta', category: 'financeiro', icon: '🕒', order: 540 },
    // admin
    // { slug: 'users', name: 'Usuários', category: 'admin', icon: '👥', order: 610 },
    { slug: 'system_logs', name: 'Logs do Sistema', category: 'admin', icon: '📃', order: 620 },
    { slug: 'settings', name: 'Configurações', category: 'admin', icon: '⚙️', order: 630 },
    // Feature flags — admin-only (verificado no frontend). Não incluído no seed
    // de user.modules porque a rota já gateia por role='admin' na tela. Está no
    // catálogo pra o Sidebar montar o item automaticamente pra admin (que vê
    // todos os slugs, independentemente do array `modules`).
    { slug: 'feature_flags', name: 'Feature Flags', category: 'admin', icon: '🚩', order: 640 },
];
export const CATEGORY_LABELS = {
    principal: 'Principal',
    carregadores: 'Carregadores',
    operacao: 'Operação',
    gestao_eletrica: 'Gestão Elétrica',
    frota: 'Frota',
    financeiro: 'Financeiro',
    admin: 'Administração',
};
// ============================================================
// Contrato de Relatórios (Codex ↔ Claude Code em AGENT_COORDINATION.txt)
// Endpoint principal: GET /api/fleet-performance
// Endpoint drill-down: GET /api/fleet-performance/rankings
// ============================================================
/** Indicador canônico. Frontend usa esta constante como discriminador. */
export const RELATORIOS_INDICADOR_KWH_KM = 'kwh_por_km';
